<template>
  <div id="audio-settings">
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title>{{$t('media_type_audio')}}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>

    <div class="pa-3">
      <div style="text-align:left; max-width:100%; width:100vh" >
        <v-select
          width="100%"
          v-model="defaultOutput"
          :items="outputDevices"
          item-text="name"
          item-value="id"
          :label="$t('settings_output_audio')"
          v-on:change="outputSelected()"
        ></v-select>
        <v-slider
          width="100%"
          v-model="outputVolume"
          append-icon="volume_up"
          prepend-icon="volume_down"
          min="0"
          max="100"
          step="1"
          thumb-label
          v-on:mouseup = "outputVolumeChanged()"
        ></v-slider>

        <v-select
          width="100%"
          v-model="defaultInput"
          :items="inputDevices"
          item-text="name"
          item-value="id"
          :label="$t('settings_input_audio')"
          v-on:change="inputSelected()"
        ></v-select>
        <v-slider
          width="100%"
          v-model="inputVolume"
          append-icon="volume_up"
          prepend-icon="volume_down"
          min="0"
          max="100"
          step="1"
          thumb-label
          v-on:mouseup = "inputVolumeChanged()"
        ></v-slider>
      </div>

      <v-layout justify-end>
        <v-btn outline @click="echoCall" :disabled="$store.getters.isCallBusy">{{$t('contacts_echo')}}</v-btn>
      </v-layout >

      <v-divider class="devider"></v-divider>
      <div style="text-align:left; max-width:100%; width:100vh">
        <v-select
          width="100%"
          v-model="incomingMessageSound"
          :items="messagesSound"
          :label="$t('incoming_messages_title')"
          v-on:change="incomingMessageSoundChanged"
        />
        <v-select
          width="100%"
          v-model="outgoingMessageSound"
          :items="messagesSound"
          :label="$t('outgoing_messages_title')"
          v-on:change="outgoingMessageSoundChanged"
        />
        <v-select
          width="100%"
          v-model="callSound"
          :items="sound"
          :label="$t('settings_call_sound')"
          v-on:change="callSoundChanged"
        />
      </div>
    </div>
  </div>  
</template>

<style>
#audio-settings .v-input--slider {
  margin-top: 0 !important;
}
#audio-settings .v-btn {
  padding: 0 !important;
  margin: 6px 0 !important;
}

</style>

<script>
  export default {
    data () {
      return {
        outputVolume: 1,
        inputVolume: 0.7,
        outputDevices: [],
        defaultOutput: 0,
        inputDevices: [],
        defaultInput: 0,
        messagesSound: [
          "Beep",
          "Guitar",
          "Piano"
        ],
        sound:[
          "Standard",
          "Guitar",
          "Piano"
        ],
        incomingMessageSound: "Beep",
        outgoingMessageSound: "Beep",
        callSound: "Standard",
      }
    },
    mounted() {
      this.fetchAudioSettings()

      let s = this.$store.state.settings
      this.defaultInput = s.input

      if (s.incomingMessageSound !== undefined)
        this.incomingMessageSound = s.incomingMessageSound
      if (s.outgoingMessageSound !== undefined)
        this.outgoingMessageSound = s.outgoingMessageSound
      if (s.callSound !== undefined)
        this.callSound = s.callSound

      console.log('settings:', s)
    },
    methods: {
      fetchAudioSettings() {
        this.$store.dispatch('getAudioSettings').then(result => {
          console.log('getAudioSettings', result)

          this.outputDevices = result.output
          this.inputDevices = result.input
          this.outputVolume = result.outputVolume
          this.inputVolume = result.inputVolume
          this.defaultOutput = result.outputDefault
          this.defaultInput = result.inputDefault
        })
      },
      outputSelected() {
        console.log("setAudioOutputDevice", this.defaultOutput)
        this.$store.dispatch('setAudioOutputDevice', this.defaultOutput).then((result) => {
          console.log(result)
        })
      },
      inputSelected() {
        console.log("setAudioInputDevice")
        this.$store.dispatch('setAudioInputDevice', this.defaultInput).then((result) => {
          console.log(result)
        })
      },
      outputVolumeChanged() {
        console.log("setAudioOutputVolume", this.outputVolume)
        this.$store.dispatch('setAudioOutputVolume', this.outputVolume).then((result) => {
          console.log(result)
        })
      },
      inputVolumeChanged() {
        console.log("setAudioOutputVolume", this.outputVolume)
        this.$store.dispatch('setAudioInputVolume', this.inputVolume).then((result) => {
          console.log(result)
        })
      },
      incomingMessageSoundChanged() {
        let s = this.$store.state.settings
        s.incomingMessageSound = this.incomingMessageSound
        this.$store.dispatch('updateSettings', s)
      },
      outgoingMessageSoundChanged() {
        let s = this.$store.state.settings
        s.outgoingMessageSound = this.outgoingMessageSound
        this.$store.dispatch('updateSettings', s)
      },
      callSoundChanged() {
        let s = this.$store.state.settings
        s.callSound = this.callSound
        this.$store.dispatch('updateSettings', s)
      },
      echoCall() {
        this.$store.dispatch('call', ['#1'])
      }
    }
  }
</script>

